import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.ASSET_VERSION}/`;

export const GetVersionTemplatesAPI = ({ onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}templates`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const UpdateAssetVersionsAPI = ({ payload, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}draftscheduleprogram`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.PATCH,
    payload,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
